export default __webpack_public_path__ + "static/media/Roof.91d588ae.jpg";